import Vue from 'vue'

export const eventBus = new Vue()



// WEBPACK FOOTER //
// ./src/event-bus/eventBus.js